// extracted by mini-css-extract-plugin
module.exports = {"pComponent":"style_pComponent__2EptH"};